import HeaderSale from "./components/HeaderSale";
import FooterSale from "./components/FooterSale";

if (!("customElements" in window)) {
  setTimeout(() => {
    if (!window.customElements.get("arcteryx-sale-header")) {
      window.customElements.define("arcteryx-sale-header", HeaderSale);
    }

    if (!window.customElements.get("arcteryx-sale-footer")) {
      window.customElements.define("arcteryx-sale-footer", FooterSale);
    }
  }, 2000);
}

if (!window.customElements.get("arcteryx-sale-header")) {
  window.customElements.define("arcteryx-sale-header", HeaderSale);
}

if (!window.customElements.get("arcteryx-sale-footer")) {
  window.customElements.define("arcteryx-sale-footer", FooterSale);
}
